import {Injectable} from '@angular/core';
import {LokijsService} from './database/lokijs.service';
import {CollectionsNames} from '../definitions/collections-names';
import {ConfigurationModel} from '../models/configuration.model';
import {ConfigurationService} from './configuration.service';

@Injectable({
    providedIn: 'root'
})
export class PersistScannedBarcodesService {
    configuration: ConfigurationModel;

    constructor(private loki: LokijsService,
                private collectionsNames: CollectionsNames,
                private configurationService: ConfigurationService) {
    }

    async persistBarcode(barcode) {
        // await this.sanitizeScannedBarcodes();
        if (barcode) {
            const data = {
                barcode: barcode,
                date: this.generateDate()
            };
            this.loki.upsert(this.collectionsNames.SCANNEDBARCODES, 'barcode', data);
            this.loki.saveDatabase();
        }
    }

    async sanitizeScannedBarcodes() {
        this.configuration = this.configurationService.getConfiguration();
        if (!this.configuration.lastMattressScanned || this.configuration.lastMattressScanned !== this.generateDate()) {
            this.configuration.lastMattressScanned = this.generateDate();
            let scannedCodes = this.loki.getCollection(this.collectionsNames.SCANNEDBARCODES).chain().data();
            scannedCodes = scannedCodes.filter(barcode => {
                return this.generateDate(barcode.date) === this.generateDate();
            });
            this.loki.getCollection(this.collectionsNames.SCANNEDBARCODES).clear();
            await this.loki.bulkUpsert(this.collectionsNames.SCANNEDBARCODES, 'barcode', scannedCodes);
            this.configurationService.saveConfiguration(this.configuration);
        }

    }

    generateDate(date = new Date()): string {
        const result = new Date(date);
        result.setHours(0);
        result.setMinutes(0);
        result.setSeconds(0);
        result.setMilliseconds(0);
        return result.toISOString();
    }
}
